import type React from "react";
import type { ReactNode } from "react";
import { Button } from "~/components/common/parts/button/Button";
import { CancelButton } from "~/components/common/parts/button/CancelButton";
import { Modal } from "~/components/common/parts/modal/Modal";
import Styles from "./ConfirmModal.module.scss";

type ConfirmType = "delete" | "save";
type Props = {
	actionText?: string;
	cancelText?: string;
	children: React.ReactNode;
	confirmType: ConfirmType;
	disabled?: boolean;
	handleAccept: () => void | Promise<void>;
	handleCancel: () => void;
	isOpen: boolean;
	title?: string;
};

export const ConfirmModal: React.FC<Props> = ({
	isOpen,
	children,
	handleCancel,
	handleAccept,
	title = "確認",
	confirmType,
	actionText,
	cancelText = "キャンセル",
	disabled = false
}: Props) => {
	const footer = ((): ReactNode => {
		if (confirmType === "save") {
			return (
				<>
					<CancelButton
						className={Styles.Button}
						label={cancelText}
						onClick={handleCancel}
					/>
					<Button
						className={Styles.AcceptButton}
						disabled={disabled}
						onClick={handleAccept}
						variant="primary"
					>
						{actionText ?? "保存"}
					</Button>
				</>
			);
		}
		return (
			<>
				<CancelButton label={cancelText} onClick={handleCancel} />
				<Button
					className={Styles.AcceptButton}
					disabled={disabled}
					onClick={handleAccept}
					variant="danger"
				>
					{actionText ?? "削除"}
				</Button>
			</>
		);
	})();
	return (
		<Modal
			footers={footer}
			handleClose={handleCancel}
			isOpen={isOpen}
			title={title}
		>
			{children}
		</Modal>
	);
};
